import "core-js/modules/es6.object.assign";
import { useMemo, useCallback, createElement, Fragment } from 'react';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var DefaultComp = function DefaultComp(_ref) {
  var type = _ref.type;
  throw new Error("Could not find a component mapping for type \"" + type + "\"");
};

var MapToComponents = function MapToComponents(props) {
  var getKey = props.getKey,
      getType = props.getType,
      _props$list = props.list,
      list = _props$list === void 0 ? [] : _props$list,
      map = props.map,
      meta = props.meta,
      mapDataToContext = props.mapDataToContext,
      mapDataToProps = props.mapDataToProps,
      _props$default = props["default"],
      defaultMapping = _props$default === void 0 ? DefaultComp : _props$default,
      defaultMapDataToContext = props.defaultMapDataToContext,
      defaultMapDataToProps = props.defaultMapDataToProps;
  var keys = useMemo(function () {
    return list.map(getKey);
  }, [list, getKey]);
  var types = useMemo(function () {
    return list.map(getType);
  }, [list, getType]);
  var comps = useMemo(function () {
    return types.map(function (type) {
      var _map$type;

      return (_map$type = map[type]) !== null && _map$type !== void 0 ? _map$type : defaultMapping;
    });
  }, [types, map, defaultMapping]);
  var gatherData = useCallback(function (index) {
    return {
      list: list,
      keys: keys,
      types: types,
      comps: comps,
      map: map,
      meta: meta,
      index: index,
      data: list[index],
      key: keys[index],
      type: types[index],
      Comp: comps[index],
      previousData: list[index - 1],
      previousKey: keys[index - 1],
      previousType: types[index - 1],
      PreviousComp: comps[index - 1],
      nextData: list[index + 1],
      nextKey: keys[index + 1],
      nextType: types[index + 1],
      NextComp: comps[index + 1]
    };
  }, [comps, keys, types, meta, list, map]);
  var contexts = useMemo(function () {
    return list.map(function (_, index) {
      var _mapDataToContext$typ;

      var fn = (_mapDataToContext$typ = mapDataToContext === null || mapDataToContext === void 0 ? void 0 : mapDataToContext[types[index]]) !== null && _mapDataToContext$typ !== void 0 ? _mapDataToContext$typ : defaultMapDataToContext;
      return fn ? fn(gatherData(index)) : undefined;
    });
  }, [gatherData, list, mapDataToContext, types, defaultMapDataToContext]);
  var gatherDataForMapDataToProps = useCallback(function (index) {
    return _extends({}, gatherData(index), {
      contexts: contexts,
      context: contexts[index],
      previousContext: contexts[index - 1],
      nextContext: contexts[index + 1]
    });
  }, [gatherData, contexts]);
  var propsList = useMemo(function () {
    return list.map(function (_, index) {
      var _mapDataToProps$types;

      var fn = (_mapDataToProps$types = mapDataToProps === null || mapDataToProps === void 0 ? void 0 : mapDataToProps[types[index]]) !== null && _mapDataToProps$types !== void 0 ? _mapDataToProps$types : defaultMapDataToProps;
      return fn ? fn(gatherDataForMapDataToProps(index)) : undefined;
    });
  }, [gatherDataForMapDataToProps, list, mapDataToProps, types, defaultMapDataToProps]);
  return createElement(Fragment, null, propsList.map(function (mappedProps, index) {
    var comp = comps[index];
    var type = types[index];
    var isDefault = comp === defaultMapping;
    return createElement(comp, Object.assign(_extends({
      key: keys[index]
    }, mappedProps), isDefault ? {
      type: type
    } : undefined));
  }));
};

export default MapToComponents;
export { MapToComponents };